<template>
  <v-app style="
    background-image: radial-gradient(#8be299, #243029);
  ">
  <div style="text-align:center">
        <section class="section">
            <div class="container cardviewer">
              <v-app-bar app color="#006B38FF" dark>
                <img src="@/assets/parley_1.png" class="navbarLogo">
                <v-container fluid>
                    <SearchBar />
                </v-container>
                <a class="button is-light loginbutton" v-if='authenticated' v-on:click='logout' id='logout-button'> Logout </a>
                <a class="button is-light loginbutton" v-else v-on:click='login' id='login-button'> Login </a>
              </v-app-bar>
              <v-main>
                  <v-container fluid>
                      <v-row class="fill-height cardviewer">
                          <v-col>
                              <transition name="fade">
                                <router-view/>
                              </transition>
                          </v-col>
                      </v-row>
                  </v-container>
                  <v-footer style="background-color: #CCE0DC">
                      ParleyMTG brought to you by Gixed
                  </v-footer>
              </v-main>
            </div>
        </section>
    </div>
  </v-app>
</template>

<script>
import SearchBar from './SearchBar'
import store from '../store'
import { BACKEND_BASE_URL } from '../config'

export default {
  components: {
    SearchBar
  },
  data: function () {
    return {
      authenticated: false
    }
  },
  created () {
    var session = this.$route.query.session
    if (session != null) {
      store.dispatch('setSessionCookie', session)
      this.$cookies.set('session_token', session)
    } else {
      var cookie = this.$cookies.get('session_token')
      if (cookie != null) {
        store.dispatch('setSessionCookie', cookie)
      } else {
        // not logged in
        store.dispatch('setSessionCookie', null)
      }
    }
    if (store.state.session == null) {
      this.authenticated = false
    } else {
      this.authenticated = true
    }
  },
  watch: {
  },
  methods: {
    login () {
      window.location.href = BACKEND_BASE_URL + "/login/facebook"
    },
    logout () {
      window.location.href = BACKEND_BASE_URL + "/logout"
    }
  }
}
</script>
